
import { toast } from "sonner";
import { RedirectionRule, CanonicalRule } from './types';
import { getDefaultRedirectionRules } from './redirectionRules';
import { getDefaultCanonicalRules } from './canonicalRules';
import { Canonicalizer } from './canonicalizer';
import { SEODetector } from './seoDetector';
import { ReportGenerator } from './reportGenerator';

export class RedirectionService {
  private static instance: RedirectionService;
  private redirections: RedirectionRule[] = [];
  private canonicals: CanonicalRule[] = [];

  private constructor() {
    this.initializeDefaultRules();
  }

  public static getInstance(): RedirectionService {
    if (!RedirectionService.instance) {
      RedirectionService.instance = new RedirectionService();
    }
    return RedirectionService.instance;
  }

  private initializeDefaultRules() {
    this.redirections = getDefaultRedirectionRules();
    this.canonicals = getDefaultCanonicalRules();
  }

  public checkRedirection(currentPath: string): RedirectionRule | null {
    return this.redirections.find(rule => 
      currentPath === rule.from || 
      currentPath.startsWith(rule.from + '/') ||
      currentPath.startsWith(rule.from + '?')
    ) || null;
  }

  public getCanonical(currentPath: string): string {
    return Canonicalizer.getCanonical(currentPath, this.canonicals);
  }

  public detectOrphanedUrls(): string[] {
    return SEODetector.detectOrphanedUrls();
  }

  public detectDuplicateContent(): { original: string; duplicates: string[] }[] {
    return SEODetector.detectDuplicateContent();
  }

  public addRedirection(rule: RedirectionRule): void {
    this.redirections.push(rule);
    console.log(`Redirection ajoutée: ${rule.from} → ${rule.to} (${rule.type})`);
  }

  public addCanonical(rule: CanonicalRule): void {
    this.canonicals.push(rule);
    console.log(`Canonicalisation ajoutée: ${rule.path} → ${rule.canonical}`);
  }

  public generateRedirectionReport(): string {
    return ReportGenerator.generateRedirectionReport(this.redirections, this.canonicals);
  }
}

export default RedirectionService;
